var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiAccountEditOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MDI_account-edit-outline",
    "data-name": "MDI / account-edit-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_account-edit-outline",
    "data-name": "Path / account-edit-outline",
    d: "M2,17v3h8V18.11H3.9V17c0-.64,3.13-2.1,6.1-2.1a11.694,11.694,0,0,1,2.83.38l1.52-1.52A14.508,14.508,0,0,0,10,13c-2.67,0-8,1.33-8,4M10,4a4,4,0,1,0,4,4,4,4,0,0,0-4-4m0,6a2,2,0,1,1,2-2,2,2,0,0,1-2,2m11.7,3.35-1,1-2.05-2,1-1a.549.549,0,0,1,.77,0l1.28,1.28a.549.549,0,0,1,0,.77M12,18.94l6.06-6.06,2.05,2-6,6.07H12V18.94",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiAccountEditOutline);
export default __webpack_public_path__ + "static/media/MDI - account-edit-outline.e7dd2c8ef2d806af48561aa8c99177cc.svg";
export { ForwardRef as ReactComponent };